import { FormattedMessage } from "react-intl"

export const notification = {
    GET_FAIL: <FormattedMessage id="Constants.GET_FAIL" />,
    CREATE_SUCCESS: <FormattedMessage id="Constants.CREATE_SUCCESS" />,
    CREATE_FAIL: <FormattedMessage id="Constants.CREATE_FAIL" />,
    UPDATE_SUCCESS: <FormattedMessage id="Constants.UPDATE_SUCCESS" />,
    UPDATE_FAIL: <FormattedMessage id="Constants.UPDATE_FAIL" />,
    UPDATE_PASS_SUCCESS: <FormattedMessage id="Constants.UPDATE_PASS_SUCCESS" />,
    UPDATE_PASS_FAIL: <FormattedMessage id="Constants.UPDATE_PASS_FAIL" />,
    DELETE_SUCCESS: <FormattedMessage id="Constants.DELETE_SUCCESS" />,
    DELETE_FAIL: <FormattedMessage id="Constants.DELETE_FAIL" />,
    RESEND_SUCCESS: <FormattedMessage id="Constants.RESEND_SUCCESS" />,
    RESEND_FAIL: <FormattedMessage id="Constants.RESEND_FAIL" />,
    SUCCESS: <FormattedMessage id="Constants.SUCCESS" />,
    FAIL: <FormattedMessage id="Constants.FAIL" />,
    MESSAGE_ERROR: <FormattedMessage id="Constants.MESSAGE_ERROR" />,
    MESSAGE_ERROR_SEARCH: <FormattedMessage id="Constants.MESSAGE_ERROR_SEARCH" />,
    MESSAGE_ERROR_LOAD: <FormattedMessage id="Constants.MESSAGE_ERROR_LOAD" />,
    MESSAGE_VALIDATE: <FormattedMessage id="Constants.MESSAGE_VALIDATE" />,
    SEND_EMAIL_SUCCESS: <FormattedMessage id="Constants.SEND_EMAIL_SUCCESS" />,
    SEND_EMAIL_FAIL: <FormattedMessage id="Constants.SEND_EMAIL_FAIL" />,
    CHECK_SUCCESS: <FormattedMessage id="Constants.CHECK_SUCCESS" />,
    CHECK_FAIL: <FormattedMessage id="Constants.CHECK_FAIL" />,
    NOTIFY_READ: <FormattedMessage id="Constants.NOTIFY_READ" />,
    NOTIFY_DELETE: <FormattedMessage id="Constants.NOTIFY_DELETE" />,
    FILE_DOES_NOT_EXIST: <FormattedMessage id="Constants.FILE_DOES_NOT_EXIST" />,
    FILE_UPLOAD_SUCCESS: <FormattedMessage id="Constants.FILE_UPLOAD_SUCCESS" />,
    CTS_NOT_FOUND: <FormattedMessage id="Constants.CTS_NOT_FOUND" />,
    NOTIFY: <FormattedMessage id="Constants.NOTIFY" />,
    NOT_SIGN_REMOTE: <FormattedMessage id="Constants.NOT_SIGN_REMOTE" />,
    NOT_AGENCY_CYBER_ID: <FormattedMessage id="Constants.NOT_AGENCY_CYBER_ID" />,
    SIGN_SUCCESS: <FormattedMessage id="Constants.SIGN_SUCCESS" />,
    NOT_FOUND_PLUGIN: <FormattedMessage id="Constants.NOT_FOUND_PLUGIN" />,
    MESSAGE_ERROR_SIGN: <FormattedMessage id="Constants.ERROR_DURING_SIGN" />,
    SUBMISSION_NOT_NEED_LOCATION: <FormattedMessage id="Constants.SUBMISSION_NOT_NEED_LOCATION" />,
    CONTRACT_NOT_NEED_LOCATION: <FormattedMessage id="Constants.CONTRACT_NOT_NEED_LOCATION" />,
    CONTRACT_DOCUMENT_NOT_NEED_LOCATION: <FormattedMessage id="Constants.CONTRACT_DOCUMENT_NOT_NEED_LOCATION" />,
    SUBMISSION_STARTED: <FormattedMessage id="Constants.SUBMISSION_STARTED" />,
    NO_MANAGER: <FormattedMessage id="Constants.NO_MANAGER" />,
    CONTRACT_NOT_THIS_STEP: <FormattedMessage id="Constants.CONTRACT_NOT_THIS_STEP" />,
    CONTRACT_STARTED: <FormattedMessage id="Constants.CONTRACT_STARTED" />,
    SUBMISSION_NOT_EDIT: <FormattedMessage id="Constants.SUBMISSION_NOT_EDIT" />,
    CONTRACT_NOT_EDIT: <FormattedMessage id="Constants.CONTRACT_NOT_EDIT" />,

    TOKEN_100: <FormattedMessage id="Constants.TOKEN_100" />,
    TOKEN_101: <FormattedMessage id="Constants.TOKEN_101" />,
    TOKEN_102: <FormattedMessage id="Constants.TOKEN_102" />,
    TOKEN_103: <FormattedMessage id="Constants.TOKEN_103" />,
    TOKEN_104: <FormattedMessage id="Constants.TOKEN_104" />,
    TOKEN_105: <FormattedMessage id="Constants.TOKEN_105" />,
    TOKEN_106: <FormattedMessage id="Constants.TOKEN_106" />,
    TOKEN_107: <FormattedMessage id="Constants.TOKEN_107" />,

    NOT_PERMISSION: <FormattedMessage id="Constants.NOT_PERMISSION" />,
    COPY_LINK: <FormattedMessage id="Constants.COPY_LINK" />,
    MAX_STEP_SIGN: <FormattedMessage id="Constants.MAX_STEP_SIGN" />,
    REQUIRED_METHOD_SUBMIT_REPORT: <FormattedMessage id="Constants.REQUIRED_METHOD_SUBMIT_REPORT" />
}


